import React from 'react'
import { Spin } from 'antd'
import PropTypes from 'prop-types'
import './Spinner.less'
import ReactLoading from 'react-loading';

const Spinner = ({ type, text, isLoading, children }) => {

    let classes = ['spinner']
    if (type === 'fullpage')
        classes.push('spinner-fullpage')
    else
        classes.push('spinner-filled')

    const SpinStroked = ({ type, color, className }) => (
        <ReactLoading className={className} type={type} color={color} height={48} width={48} />
    );

    return <Spin
        tip={text}
        spinning={isLoading === undefined ? true : isLoading}
        className={classes.join(" ")}
        size="large"
        indicator={<SpinStroked className="loading-spinner-stroke" type="spin" />}
    >
        {children}
    </Spin>
}

Spinner.propTypes = {
    text: PropTypes.string,
    isLoading: PropTypes.bool,
    type: PropTypes.oneOf(['fullpage', 'filled'])
}

export default Spinner